import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import Image from '@/components/Image';
import { Typography } from '@/components/shared/Typography';
import { IntroPill } from '@/types/lead-magnet';
import css from './style.module.scss';
interface Props {
  pills: IntroPill[];
  className?: string;
}
const LeadMagnetPills: FC<Props> = t0 => {
  const $ = _c(7);
  const {
    pills,
    className
  } = t0;
  if (!pills.length) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = [css.pills, className].filter(Boolean);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1.join(" ");
  let t3;
  if ($[2] !== pills) {
    t3 = pills.map(_temp);
    $[2] = pills;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <ul className={t2}>{t3}</ul>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default LeadMagnetPills;
function _temp(pill) {
  return <li key={pill.id} className={css.pill}>{pill.icon ? <Image className={css.icon} src={pill.icon.url} alt="" width={pill.icon.width ?? 16} height={pill.icon.height ?? 16} /> : null}<Typography uppercase={true} variant="body-s" tag="span" className={css.label}>{pill.label}</Typography></li>;
}